import React, { useMemo } from 'react';
import { Box, Text } from '@common-fe/common-fe';
import _ from 'lodash';

import theme from '@/styles/theme';

import { IEmployerCalendarCategory } from '../../Dashboard.type';

import { EmployerCalendarPayload } from './EmployerCalendar.types';

interface Props {
  dates: EmployerCalendarPayload[];
}
const MAX_DISPLAYED_AMOUNT = 3;

const ORDER = [IEmployerCalendarCategory.PLAN_DATES, IEmployerCalendarCategory.FUNDING];
const EmployerCalendarDayEvents: React.FC<Props> = ({ dates = [] }) => {
  const groupedBy = useMemo(() => {
    const groups = _.groupBy(dates, (item) => item.category || item.invoiceStatus);

    return groups;
  }, [dates]);

  const renderList = (key: IEmployerCalendarCategory, dates?: EmployerCalendarPayload[]) => {
    if (!dates) {
      return null;
    }
    if (dates.length > MAX_DISPLAYED_AMOUNT) {
      return (
        <Box align="center" direction="row" gap="2px">
          <Box
            data-testid="employer-calendar-day-events_dot"
            width="5px"
            height="5px"
            round="50%"
            background={key === IEmployerCalendarCategory.FUNDING ? theme.colors.fund2 : theme.colors.fund3}
          />
          <Text
            size="small"
            weight="bold"
            style={{ lineHeight: '5px' }}
            color={key === IEmployerCalendarCategory.FUNDING ? theme.colors.fund2 : theme.colors.fund3}
          >
            {dates.length || 0}
          </Text>
        </Box>
      );
    }
    return (
      <Box direction="row" align="center" gap="2px">
        {dates.map((item) => (
          <Box
            key={item.id}
            data-testid={`employer-calendar-day-events_dot-${item.id}`}
            width="5px"
            height="5px"
            round="50%"
            background={key === IEmployerCalendarCategory.FUNDING ? theme.colors.fund2 : theme.colors.fund3}
          />
        ))}
      </Box>
    );
  };

  if (!dates.length) {
    return null;
  }

  return (
    <Box
      data-testid="employer-calendar-day-events"
      direction="row"
      align="center"
      justify="center"
      wrap
      style={{ position: 'absolute', bottom: '2px' }}
      gap="4px"
    >
      {ORDER.map((key) => (
        <Box key={key}>{renderList(key, groupedBy[key])}</Box>
      ))}
    </Box>
  );
};
export default EmployerCalendarDayEvents;
